export const SIDEBAR_LOCAL_STORAGE_VARIABLE = 'isSideBarCollapsed'
